import Vue from 'vue'
import Vuex from 'vuex'

Vue.use(Vuex)

import * as user from "./userInfo/index";

export default new Vuex.Store({
  state: {
    // 首页展示的模块
    activeMode: '', 
    // 分销商
    retailer:'', 
  },
  getters: {
  },
  mutations: {
    setActiveMode(state, data){
      state.activeMode = data;
    },
    setRetailer(state, data){
      state.retailer = data;
    }
  },
  actions: {
  },
  modules: {
    user
  }
})
